import React from 'react'

export default ({
  className = ''
}) => (
<svg className={className} xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16.5 44">
  <path d="M1.719-2.043A1.719,1.719,0,0,0,0-.324V3.781A1.719,1.719,0,0,0,1.719,5.5H14.781A1.719,1.719,0,0,0,16.5,3.781V-.324a1.719,1.719,0,0,0-1.719-1.719H13.063V-20.281A1.719,1.719,0,0,0,11.344-22H1.719A1.719,1.719,0,0,0,0-20.281v4.105a1.719,1.719,0,0,0,1.719,1.719H3.438V-2.043ZM8.25-38.5a6.187,6.187,0,0,0-6.187,6.188A6.187,6.187,0,0,0,8.25-26.125a6.187,6.187,0,0,0,6.188-6.187A6.188,6.188,0,0,0,8.25-38.5Z" transform="translate(0 38.5)" />
</svg>
  )
